import React, { useContext, Fragment } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { Field } from 'formik';
import { Row, Form, Subtext, InputPlaceholder } from '@contently/toolkit';
import { FormikHandlersContext } from './DynamicFormikForm';

const BasicInput = props => {
  const {
    errors,
    id,
    name,
    label,
    placeholder,
    subtext,
    touched,
    type,
    value,
    required,
    validate
  } = props;

  const { handleChange, handleBlur, isFetching } = useContext(FormikHandlersContext);

  const renderSubtext = () => (typeof subtext === 'string' ? subtext : subtext());

  const validation = input => {
    if (required) {
      if (!input || !input.length) {
        return 'This field is required';
      }
    }
    if (validate) {
      return validate(input);
    }
    return undefined;
  };

  return (
    <Row>
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!isFetching}
      >
        <Form.Label required={required} htmlFor={id}>
          {label}
        </Form.Label>
        {subtext && <Subtext>{renderSubtext()}</Subtext>}
        <Field name={id} validate={validation}>
          {({ field, _form }) => (
            <Form.ErrorWrapper touched={touched} error={errors}>
              <Form.Input
                {...field}
                type={type}
                onChange={handleChange}
                onBlur={handleBlur}
                value={value || ''}
                name={field.name}
                id={id}
                placeholder={placeholder}
                required={required}
              />
            </Form.ErrorWrapper>
          )}
        </Field>
      </ReactPlaceholder>
    </Row>
  );
};

export default BasicInput;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/BasicInput.jsx